<template>
    <div class="page">
        <toolbar-system></toolbar-system>
        <progress-system :isLoad="progress"></progress-system>
        <v-container v-show="meusCursos != null" grid-list-lg>
            <v-alert class="animated flipInX" :value="true" color="blue" v-show="meusCursos == ''">Você ainda não está matriculado em nenhum curso.</v-alert>
            <br><br>
            <h1>Pré-inscrições realizadas</h1>
            <v-divider></v-divider>
            <br>
            <v-layout wrap>
                <template v-for="curso in meusCursos">
                    <v-flex v-if="curso.Efetivada == 0" :key="curso.index" xs12 sm4 md3 lg4 xl3>
                        <v-card height="180" class="animated fadeIn">
                            <v-card-title>
                                <div class="title text-truncate">{{curso.GradeDescricao}}</div>
                            </v-card-title>
                            <v-card-text>
                                <v-chip v-if="curso.Efetivada == 1" color="orange" outline dark>
                                    <v-icon left>mdi mdi-school</v-icon>
                                    <div class="text-truncate">{{curso.Segmento}}</div>
                                </v-chip>
                                <v-chip v-else color="green" outline dark>
                                    <v-icon left>mdi mdi-check</v-icon>
                                    <div class="text-truncate">Pré-inscrição realizada</div>
                                </v-chip>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn v-if="curso.Efetivada == 1"  class="blue--text text--draken-1" :href="'meus_cursos/' + curso.IdCurso" flat dark>Mais detalhes</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </template>
            </v-layout>
            <br><br>
            <h1>Inscrições efetivadas</h1>
            <v-divider></v-divider>
            <br>
            <v-layout wrap>
                <template v-for="curso in meusCursos">
                    <v-flex v-if="curso.Efetivada == 1" :key="curso.index" xs12 sm4 md3 lg4 xl3>
                        <v-card height="180" class="animated fadeIn">
                            <v-card-title>
                                <div class="title text-truncate">{{curso.GradeDescricao}}</div>
                            </v-card-title>
                            <v-card-text>
                                <v-chip v-if="curso.Efetivada == 1" color="orange" outline dark>
                                    <v-icon left>mdi mdi-school</v-icon>
                                    <div class="text-truncate">{{curso.Segmento}}</div>
                                </v-chip>
                                <v-chip v-else color="green" outline dark>
                                    <v-icon left>mdi mdi-check</v-icon>
                                    <div class="text-truncate">Pré-inscrição realizada</div>
                                </v-chip>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn v-if="curso.Efetivada == 1"  class="blue--text text--draken-1" :href="'meus_cursos/' + curso.IdCurso" flat dark>Mais detalhes</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import ToolbarSystem from '../../../components/ToolbarSystem'
import ProgressSystem from '../../../components/ProgressSystem'
export default {
    components:{
        ToolbarSystem,
        ProgressSystem
    },
    data () {
        return{
            progress: true,
            user: null,
            sideIcon: true,
            meusCursos: null
        }
    },
    methods: {
        getMeusCursos (idUsuario) {
            this.axios.get('user/' + idUsuario + '/curso').then( res => {
                this.meusCursos = res.data.reverse()
                this.progress = false
            }).catch(() => {
                this.progress = false
            })
        },
        getUser () {
            this.axios.get('user/').then( res => {
                this.user = res.data
                this.getMeusCursos(this.user.IdPessoaFisica)
            }).catch(() => {
                this.progress = false
            })
        }
    },
    mounted(){
        this.getUser()
    }
}
</script>
<style>

</style>
